import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from 'components/shared/Tabs'
import strings from 'strings'
import AuthService from '../../../../../tools/AuthService'
import { BankTransactions } from '../BankTransactions'
import StatementInsights from '../BankTransactions/StatementInsights'
import Transactions from '../Transactions'

const BankDataSection = (props) => {
  const { applicantUUID, hasPlaidAccess, creditCosts } = props
  const { bankDocsAnalysis } = AuthService.getClientFeatures()
  const [sourceTab, setSourceTab] = useState(0)

  const bankSourceTabs = [
    ...(bankDocsAnalysis ? [{ label: strings.BANK_SOURCE_TAB_STATEMENTS }] : []),
    { label: strings.BANK_SOURCE_TAB_CONNECTED }
  ]
  const connectedTabIndex = bankDocsAnalysis ? 1 : 0

  return (
    <div>
      {bankSourceTabs.length > 1 && (
        <Tabs
          data={bankSourceTabs}
          value={sourceTab}
          onChange={(event, newValue) => setSourceTab(newValue)}
        />
      )}

      {bankDocsAnalysis && (
        <Tab value={sourceTab} index={0}>
          <StatementInsights applicationId={applicantUUID} creditCosts={creditCosts} />
        </Tab>
      )}

      <Tab value={sourceTab} index={connectedTabIndex}>
        {hasPlaidAccess
          ? <Transactions {...props} />
          : <BankTransactions {...props} applicationId={applicantUUID} />}
      </Tab>
    </div>
  )
}

BankDataSection.propTypes = {
  applicantUUID: PropTypes.string,
  hasPlaidAccess: PropTypes.bool
}

export default BankDataSection
